import { bangladeshColleges } from "./bangladesh";
import { nepalcollege } from "./nepal";
import { russiaCollege } from "./russia";

export const allCollegeData = {
 Nepal: nepalcollege,
 Russia: russiaCollege,
 Bangladesh: bangladeshColleges,
};
